import { Component } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { SwapStatus } from '../../shared/constants/app-enums';
import { EvmPurchseService } from '../../services/evm-services/evm-purchase.service';

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.scss'],
})
export class ClaimComponent {
  SwapStatus = SwapStatus;
  status: SwapStatus = SwapStatus.not_started;

  isStake = false;
  lang = 'en';
  isWithdraw = false;

  constructor(
    public modalRef: BsModalRef,
    public purchaseService: EvmPurchseService,
    private translate: TranslateService,
  ) {

    this.lang = this.translate.currentLang;
    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.lang = params.lang;
    });

    this.purchaseService.$transactionUpdates.subscribe((item) => {
      this.status = item.status;
    })
  }
}


